var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nc_dynamic" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "ncd_title" }, [
      _c("ul", [
        _c(
          "li",
          {
            class: { ncdt_sel: _vm.customNewsTag === 6 },
            on: {
              click: function($event) {
                return _vm.switchCustomNews(6)
              }
            }
          },
          [_c("a", { attrs: { href: "javascript:;" } }, [_vm._v("前沿动态")])]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: { ncdt_sel: _vm.customNewsTag === 7 },
            on: {
              click: function($event) {
                return _vm.switchCustomNews(7)
              }
            }
          },
          [_c("a", { attrs: { href: "javascript:;" } }, [_vm._v("医事经纬")])]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: { ncdt_sel: _vm.customNewsTag === 8 },
            on: {
              click: function($event) {
                return _vm.switchCustomNews(8)
              }
            }
          },
          [_c("a", { attrs: { href: "javascript:;" } }, [_vm._v("病例讨论")])]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: { ncdt_sel: _vm.customNewsTag === 9 },
            on: {
              click: function($event) {
                return _vm.switchCustomNews(9)
              }
            }
          },
          [_c("a", { attrs: { href: "javascript:;" } }, [_vm._v("行业信息")])]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: { ncdt_sel: _vm.customNewsTag === 12 },
            on: {
              click: function($event) {
                return _vm.switchCustomNews(12)
              }
            }
          },
          [_c("a", { attrs: { href: "javascript:;" } }, [_vm._v("学术会议")])]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "ncd_main"
      },
      [
        _c(
          "div",
          { staticClass: "ncdm_left f_l" },
          _vm._l(_vm.customNews, function(item, index) {
            return index === 0
              ? _c("div", { staticClass: "ncdml" }, [
                  _c(
                    "div",
                    { staticClass: "ncdml_pic" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: { path: "/newsInfo", query: { id: item.id } },
                            target: "_blank"
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: item.image,
                              width: "120",
                              height: "90"
                            }
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ncdml_main" }, [
                    _c(
                      "p",
                      { staticClass: "ncdml_main_title textover" },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: { path: "/newsInfo", query: { id: item.id } },
                              target: "_blank"
                            }
                          },
                          [_vm._v(_vm._s(item.newsTitle))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "ncdml_main_text" }, [
                      _c("a", { attrs: { href: "javascript:;" } }, [
                        _vm._v(
                          _vm._s(
                            item.description.length > 450
                              ? item.description.substring(0, 450) + "..."
                              : item.description
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "ncdml_main_detail" },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: { path: "/newsInfo", query: { id: item.id } },
                              target: "_blank"
                            }
                          },
                          [_vm._v("[阅读详细]")]
                        )
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e()
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "ncdm_right f_r" }, [
          _c(
            "ul",
            _vm._l(_vm.customNews, function(item, index) {
              return index > 0
                ? _c(
                    "li",
                    { key: item.id },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: { path: "/newsInfo", query: { id: item.id } },
                            target: "_blank"
                          }
                        },
                        [_vm._v(_vm._s(item.newsTitle) + "\n        ")]
                      ),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$moment(item.publishTime).format("YYYY-MM-DD")
                          )
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e()
            }),
            0
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nc_title" }, [
      _c("p", { staticClass: "nc_title_L" }, [_vm._v("医学动态")]),
      _vm._v(" "),
      _c("p", { staticClass: "nc_title_S" }, [
        _c("span", [_vm._v("成都中医药大学 — 为您提供最新动态")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69d80a11", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69d80a11","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MedicalDynamicNews.vue
// module id = null
// module chunks = 